import { ModuleConfig } from '@core/interfaces';

const config: ModuleConfig = {
  name: 'Busk',
  baseUrl: '',
  routes: [
    {
      path: '/admin/busk/stock/:id',
      page: 'BuskStockDetail',
      title: 'Busk Admin stock',
      exact: true
    }
  ],
  requireAuthenticated: true
};

export default config;
